




























































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';

import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';
import Attachments from '@/components/Controls/Attachments.vue';
import ShiftAtomCoockPlanForm from './ShiftAtomCoockPlanForm/ShiftAtomCoockPlanForm.vue';
import ShiftAtomCoockPlanItemForm from './ShiftAtomCoockPlanItemForm/ShiftAtomCoockPlanItemForm.vue';
import ShiftAddWashForm from '../ShiftAddWashForm/ShiftAddWashForm.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedPlansList', 'prevPlansList'
    ]),
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ['addItem', 'removeItem'])
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox,
    Attachments
  }
})
export default class ShiftAtomCoockPlan extends Vue {

  @Prop() documentId!: string;
  @Prop() realBeginTime!: string;
  @Prop() realEndTime!: string;
  @Prop() relTimeOfDay!: string;

  relatedPlansList!: any[];
  actor!: any;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  @Watch('realBeginTime')
  onrealBeginTime() {
    console.log('bt => ', this.realBeginTime)
    this.loadData()
  }

  public mounted() {
    this.loadData()
  }

  public loadData() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      realEndTime: this.realEndTime,
      relTimeOfDay: this.relTimeOfDay
    });
  }

  get allowDelete() {
    const exists_roles: any[] = ['admin', 'manufacture_head'].filter((role: string) => (this.actor as any).roles.includes(role)) 
    return exists_roles.length > 0
  }

  sortByNumber(a: any, b: any, isArc: boolean) {
    console.log(a, b, isArc)
    const keyA = parseFloat(a.number);
    const keyB = parseFloat(b.number);
    const result = (keyA > keyB) ? 1 : ((keyA < keyB) ? -1 : 0)
    return result * (isArc ? 1 : -1)
  }

  deleteDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить партию ${row.number}?`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/deleteDocument`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }
  openEquipmentForm(equipments: any[]) {
    const numberStart = this.relatedPlansList.length ? Math.max.apply(null, this.relatedPlansList.map((i: any) => parseInt(i.number))) + 1 : 1
    this.$buefy.modal.open({
      component: ShiftAddWashForm,
      props: {
        equipments: equipments,
        typeLine: 'atom',
        initParams: {
          shift_id: this.documentId,
          numberStart: numberStart
        }
      },
      events: {
        'form-close': () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  restoreDocument(row: any) {
    this.$buefy.dialog.confirm({
      message: `Восстановить партию ${row.number}?`,
      confirmText: 'Восстановить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/restoreDocument`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись восстановлена`);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  deleteItemDocument(row: any, number: string) {
    this.$buefy.dialog.confirm({
      message: `Удалить позицию ${row.base_name} партии ${number}?`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/deleteDocument`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  restoreItemDocument(row: any, number: string) {
    this.$buefy.dialog.confirm({
      message: `Восстановить позицию ${row.base_name} партии ${number}?`,
      confirmText: 'Восстановить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/restoreDocument`, row)
        .then((result) => {
          this.$buefy.snackbar.open(`Запись восстановлена`);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  openDocument(row: any) {
    const numberStart = this.relatedPlansList.length ? Math.max.apply(null, this.relatedPlansList.map((i: any) => parseInt(i.number))) + 1 : 1
    const letter = this.relTimeOfDay ? this.relTimeOfDay[0] : ''
    this.$buefy.modal.open({
      component: ShiftAtomCoockPlanForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        initParams: {
          shift_id: this.documentId,
          number: numberStart + letter,
          ignore_done_delay: false
        }
      },
      events: {
        'form-close': (equipments: any[]) => {
          this.loadData();
          if (equipments.length) {
            this.openEquipmentForm(equipments)
          }
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openItemDocument(row: any, coock_plan_id: any, filter_base_id: any) {
    const letter = this.relTimeOfDay ? this.relTimeOfDay[0] : ''
    this.$buefy.modal.open({
      component: ShiftAtomCoockPlanItemForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        filter_base_id: filter_base_id,
        initParams: {
          coock_plan_id: coock_plan_id
        }
      },
      events: {
        'form-close': () => {
          this.loadData();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  reorderPlan(item1: any, item2: any) {
    this.$store.dispatch(`${STORE_KEY}/reorderPlan`, {item1, item2})
        .then((result) => {
          this.$buefy.snackbar.open(`Записи поменяны делами`);
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })

  }

  changeFormValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index, field, newValue: value
    })
  }
  
  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }
}

